import React from 'react'

const CaseSensitiveIcon =  (props) => {
  const { theme, isActive } = props
  return (
    <svg width='38px' height='32px' viewBox='0 0 38 32'>
      <g
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <path
          d='M17.9891077,22.7340909 L16.5730921,18.7008878 L10.9676233,18.7008878 L9.55160769,22.7340909 L7.70590456,22.7340909 L12.9012171,8.64229403 L14.6394983,8.64229403 L19.8348108,22.7340909 L17.9891077,22.7340909 Z M13.7410608,10.7809659 L11.4852014,17.2067472 L16.0555139,17.2067472 L13.7996546,10.7809659 L13.7410608,10.7809659 Z M25.7628454,21.4254972 C27.3937048,21.4254972 28.5948767,20.3219815 28.5948767,18.876669 L28.5948767,18.0661222 L25.9679236,18.2321378 C24.4640173,18.3200284 23.6827673,18.876669 23.6827673,19.8434659 C23.6827673,20.7712003 24.4933142,21.4254972 25.7628454,21.4254972 Z M25.3819861,22.8805753 C23.3214392,22.8805753 21.9542517,21.6403409 21.9542517,19.8434659 C21.9542517,18.095419 23.2921423,17.0602628 25.7726111,16.9137784 L28.5948767,16.7477628 L28.5948767,15.907919 C28.5948767,14.657919 27.7745642,13.9743253 26.2999548,13.9743253 C25.1378454,13.9743253 24.2687048,14.5700284 24.0733923,15.517294 L22.4522986,15.517294 C22.5011267,13.7887784 24.1710486,12.4801847 26.3292517,12.4801847 C28.7413611,12.4801847 30.2940954,13.7594815 30.2940954,15.7614347 L30.2940954,22.7340909 L28.6827673,22.7340909 L28.6827673,20.986044 L28.6437048,20.986044 C28.0675329,22.1090909 26.7980017,22.8805753 25.3819861,22.8805753 Z'
          fill={
            isActive
              ? theme.activeIconColor
              : theme.inactiveIconColor
          }
        />
      </g>
    </svg>
  )
}

export default CaseSensitiveIcon


